import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CiiBadgeComponent } from '../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-agence',
  standalone: true,
  imports: [RouterLink, CiiBadgeComponent],
  templateUrl: './agence.component.html',
  styleUrl: './agence.component.css'
})
export class AgenceComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Agence Web Mesh Box : Développement sur-mesure à Paris & Châteauroux");
    this.metaService.updateTag({ name: 'description', content: "Découvrez Mesh Box, agence de développement web spécialisée Node.js et Angular. Proximité locale à Châteauroux et expertise parisienne pour vos projets innovants éligibles au CII." });
  }
}